function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tr_svg__cls-2{fill:#f0f0f0}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#e30a17"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "tr_svg__cls-2",
  d: "M9.64 13a3 3 0 010-6 2.93 2.93 0 012.2 1 3.71 3.71 0 100 4 2.93 2.93 0 01-2.2 1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "tr_svg__cls-2",
  d: "M14.21 10L15 8.91l-1.28.42-.79-1.09v1.34l-1.29.42 1.29.42v1.34l.79-1.09 1.28.42-.79-1.09z"
});

function SvgTr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tr_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZTMwYTE3O30uY2xzLTJ7ZmlsbDojZjBmMGYwO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNOS42NCwxM0EzLDMsMCwwLDEsOS42NCw3YTIuOTMsMi45MywwLDAsMSwyLjIsMSwzLjcxLDMuNzEsMCwxLDAsMCw0QTIuOTMsMi45MywwLDAsMSw5LjY0LDEzWiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxNC4yMSAxMCAxNSA4LjkxIDEzLjcyIDkuMzMgMTIuOTMgOC4yNCAxMi45MyA5LjU4IDExLjY0IDEwIDEyLjkzIDEwLjQyIDEyLjkzIDExLjc2IDEzLjcyIDEwLjY3IDE1IDExLjA5IDE0LjIxIDEwIi8+PC9zdmc+";
export { SvgTr as ReactComponent };